/* eslint-disable react/no-unknown-property */
import React, { useState } from 'react';
import Container from '../../atoms/Container';
import Styles from './CarrosEletricosEconomia.css';

const calcPercentage = (currentValue = 0, maxValue = 1) => {
  const percentage = Math.min(currentValue / maxValue, 1);
  return `${percentage * 100}%`;
};

function CarrosEletricosEconomia() {
  const [values, setValues] = useState({
    km: 0,
    gas: 0,
    energy: 0,
    kmL: 8,
    kmKwh: 6,
  });

  return (
    <>
      <section id="carros-eletricos-economia">
        <Container>
          <h3 className="carros-eletricos-economia-title">
            A <b className="strong">economia</b> dos <b className="strong">carros elétricos</b>
          </h3>
          <p className="carros-eletricos-economia-subtitle">
            Um carro elétrico, por não utilizar combustível fóssil, pode proporcionar uma economia
            considerável <br className="only-mobi" />
            para seu bolso.
          </p>
          <strong className="carros-eletricos-economia-simule">
            Simule a economia de um <br className="only-mobi" />
            <b>veículo elétrico:</b>
          </strong>
          <div className="carros-eletricos-economia-simulacao">
            <div className="carros-eletricos-economia-dados">
              <div className="carros-eletricos-economia-valores">
                <div className="carros-eletricos-economia-valores-input-div">
                  <p className="carros-eletricos-economia-valores-input-div-title">
                    Distância percorrida por ano
                  </p>
                  <label className="custom-range-slider">
                    <div className="input-relative">
                      <input
                        id="carros-eletricos-economia-valores-input-mark-1"
                        type="range"
                        // defaultValue={0}
                        value={values.km}
                        onChange={(e) => {
                          const temp = e.target.value;
                          setValues({ ...values, km: temp });
                        }}
                        min="0"
                        max="200"
                        step="1"
                        name="distancia-ano"
                      />

                      {Boolean(values.km) && (
                        <span
                          className="slider-fill"
                          style={{
                            width: calcPercentage(values.km, 200),
                          }}
                        />
                      )}
                    </div>
                    {values.km < 1 && (
                      <div className="carros-eletricos-economia-valores-input-mark-1">
                        <p>200 mil km</p>
                      </div>
                    )}

                    <p
                      style={{
                        minWidth: `${values.km < 1 ? '0' : '74px'}`,
                        width: `calc(${values.km * 0.5}% + 38px)`,
                        maxWidth: '100%',
                        textAlign: 'end',
                      }}
                    >
                      {`${parseFloat(values.km)} ${values.km > 0 ? 'mil' : ''} km`}
                    </p>
                  </label>
                </div>

                <div className="carros-eletricos-economia-valores-input-prices">
                  <div className="carros-eletricos-economia-valores-input-div">
                    <p className="carros-eletricos-economia-valores-input-div-title">
                      Preço por combustível
                    </p>
                    <label className="custom-range-slider">
                      <div className="input-relative">
                        <input
                          id="carros-eletricos-economia-valores-input-mark-2"
                          type="range"
                          // defaultValue={0}
                          value={values.gas}
                          onChange={(e) => {
                            const temp = e.target.value;
                            setValues({ ...values, gas: temp });
                          }}
                          min="0"
                          max="10"
                          step="any"
                          list="preco-cobustivel"
                        />
                        {Boolean(values.gas) && (
                          <span
                            className="slider-fill"
                            style={{
                              width: calcPercentage(values.gas, 10),
                            }}
                          />
                        )}
                      </div>
                      <p
                        style={{
                          // maxWidth: '290px',
                          minWidth: '55px',
                          width: `calc(${values.gas * 10}% + 25px)`,
                          maxWidth: '100%',
                          textAlign: 'end',
                        }}
                      >
                        {`${Intl.NumberFormat('pt-br', {
                          style: 'currency',
                          currency: 'BRL',
                        }).format(values.gas)}`}
                      </p>
                    </label>
                  </div>

                  <div className="carros-eletricos-economia-valores-input-div">
                    <p className="carros-eletricos-economia-valores-input-div-title">
                      Preço da energia
                    </p>
                    <label className="custom-range-slider">
                      <div className="input-relative">
                        <input
                          id="carros-eletricos-economia-valores-input-mark-3"
                          type="range"
                          // defaultValue={0}
                          value={values.energy}
                          onChange={(e) => {
                            const temp = e.target.value;
                            setValues({ ...values, energy: temp });
                          }}
                          min="0"
                          max="3"
                          step="any"
                          list="preco-energia"
                        />
                        {Boolean(values.energy) && (
                          <span
                            className="slider-fill"
                            style={{
                              width: calcPercentage(values.energy, 3),
                            }}
                          />
                        )}
                      </div>
                      <p
                        style={{
                          // maxWidth: '290px',
                          minWidth: '55px',
                          width: `calc(${values.energy * 30}% + 43px)`,
                          maxWidth: '100%',
                          textAlign: 'end',
                        }}
                      >
                        {`${Intl.NumberFormat('pt-br', {
                          style: 'currency',
                          currency: 'BRL',
                        }).format(values.energy)}`}
                      </p>
                    </label>
                  </div>
                </div>
              </div>
              <div className="carros-eletricos-economia-resultado">
                <div className="carros-eletricos-economia-div combustivel">
                  <p className="carros-eletricos-economia-result-type">Carro a combustível</p>
                  <p className="carros-eletricos-economia-result-price">
                    <b>
                      {`${Intl.NumberFormat('pt-br', { style: 'currency', currency: 'BRL' }).format(
                        ((values.km * 1000) / values.kmL) * values.gas,
                      )}`}
                      {/* {`R$${parseFloat(((values.km * 1000) / values.kmL) * values.gas).toFixed(2)}`} */}
                    </b>
                  </p>
                  <p className="carros-eletricos-economia-result-text">Custo anual</p>
                </div>
                <div className="carros-eletricos-economia-div eletrico">
                  <p className="carros-eletricos-economia-result-type">
                    Carro elétrico{' '}
                    <img src="assets/carros-eletricos/ic_sustainability.svg" alt="" />
                  </p>
                  <p className="carros-eletricos-economia-result-price">
                    <b>
                      {`${Intl.NumberFormat('pt-br', { style: 'currency', currency: 'BRL' }).format(
                        ((values.km * 1000) / values.kmKwh) * values.energy,
                      )}`}
                      {/* {`R$${parseFloat(((values.km * 1000) / values.kmKwh) * values.energy).toFixed(
                      2,
                    )}`} */}
                    </b>
                  </p>
                  <p className="carros-eletricos-economia-result-text">Custo anual</p>
                </div>
              </div>
            </div>
            <div className="carros-eletricos-economia-total">
              <div className="carros-eletricos-economia-total-card-ctn">
                <div className="carros-eletricos-economia-total-card">
                  <h4 className="carros-eletricos-economia-total-title">
                    Economia
                    <img src="assets/carros-eletricos/ic_eletric_damage.svg" alt="" />
                  </h4>
                  <p className="carros-eletricos-economia-total-text">
                    Trocando seu veículo convencional por um veículo elétrico, você economizará:
                  </p>
                  <p className="carros-eletricos-economia-total-anual">Economia anual</p>
                  <strong className="carros-eletricos-economia-total-result">
                    <p className="carros-eletricos-economia-total-result-value">
                      {`${Intl.NumberFormat('pt-br', { style: 'currency', currency: 'BRL' }).format(
                        ((values.km * 1000) / values.kmL) * values.gas -
                          ((values.km * 1000) / values.kmKwh) * values.energy,
                      )}`}
                      {/* {`R$${parseFloat(
                        ((values.km * 1000) / values.kmL) * values.gas -
                          ((values.km * 1000) / values.kmKwh) * values.energy,
                      ).toFixed(2)}`} */}
                    </p>
                  </strong>
                </div>
                <picture>
                  <source
                    type="image/webp"
                    srcSet="assets/carros-eletricos/replacement-car-2.webp"
                  />
                  <source type="image/png" srcSet="assets/carros-eletricos/replacement-car-2.png" />
                  <img
                    className="carros-eletricos-economia-total-img"
                    src="assets/carros-eletricos/replacement-car-2.png"
                    alt="Financiamento de veículos elétricos"
                  />
                </picture>
              </div>
            </div>
          </div>
          <p className="carros-eletricos-economia-media">
            Consumo médio por combustível: 8 km/L <br />
            Consumo médio por energia: 6 km/kWh <br />
            Fontes: Neocharge, ANP, ANEEL (2022)
          </p>
          <div className="carros-eletricos-economia-circles-mb" />
          <div className="carros-eletricos-economia-circles-ds" />
        </Container>
      </section>
      <style jsx>{Styles}</style>
    </>
  );
}

export default CarrosEletricosEconomia;
